import Big from 'big.js'
import { currencyFormat } from './formatting-utils'
import { marketCapNumber } from './numbers-helper'

export const valueToCurrencyFormat = (value: Big) => {
  const stringifiedAmount = value.toString()
  const fixedAmount = value.toFixedSpecial(0)

  if (fixedAmount.length > 6) {
    return `${marketCapNumber(stringifiedAmount, '$')}`
  } else {
    return currencyFormat(stringifiedAmount)
  }
}
